import * as BABYLON from "babylonjs";
function getBoxColors(colorarr) {
  let res = [];
  let color = new BABYLON.Color4(...colorarr);
  for (let index = 0; index < 6; index++) {
    res.push(color);
  }
  return res;
}
let scal = 1;
// gltf-pipeline -i product1.glb -o d_product1.glb -d
// gltf-pipeline -i product2.glb -o d_product2.glb -d
// gltf-pipeline -i product3.glb -o d_product3.glb -d
// gltf-pipeline -i product4.glb -o d_product4.glb -d
// gltf-pipeline -i product5.glb -o d_product5.glb -d
// gltf-pipeline -i product1in.glb -o d_product1in.glb -d
// gltf-pipeline -i product2in.glb -o d_product2in.glb -d
// gltf-pipeline -i product3in.glb -o d_product3in.glb -d
// gltf-pipeline -i product4in.glb -o d_product4in.glb -d
// gltf-pipeline -i product5in.glb -o d_product5in.glb -d
// gltf-pipeline -i electricalBox.glb -o d_electricalBox.glb -d
// gltf-pipeline -i powerBox.glb -o d_powerBox.glb -d
// gltf-pipeline -i battery.glb -o d_battery.glb -d
// gltf-pipeline -i highVoltage.glb -o d_highVoltage.glb -d
// gltf-pipeline -i wind.glb -o d_wind.glb -d
// gltf-pipeline -i park.glb -o d_park.glb -d
// gltf-pipeline -i tower.glb -o d_tower.glb -d
// gltf-pipeline -i light.glb -o d_light.glb -d
export default {
  scal: scal,
  padding: 3 * scal,
  margin: 0.2 * scal,
  table: { height: 0.5 * scal },
  typesKey:{
    "一体1列1簇":"product1",
    "一体2列1簇":"product2",
    "一体箱式":"product3",
    "一体箱式20簇":"product6",
    "分体电池仓3簇":"product4",
    "分体电池仓箱式":"product5",
    "一体6列3簇":"product6",
    "一体2列3簇":"product7",
    "功率仓-集装箱":"powerBox",
    "电气仓-PCS":"electricalBox",
    "干湿升压变":"product2",
    "风车":"wind",
    "停车":"park",
    "光伏":"light",
    "电塔":"tower",
  },
  //一体1列1簇  红
  product1: {
    width: 1.435 * scal,
    height: 2.0952 * scal,
    depth: 1.06405 * scal,
    faceColors: getBoxColors([1, 0, 0, 1]),
    logo:{
      size:0.05,
      poi:[0.150,1.500,0.600]
    },
    cu:{
      bigcu:[{
        start:[0.225,0.32,0]
      }],
      row:1,
      num:1,
      height:8,
      modelMarginW:0.101/10,
      modelMarginH : 0.00/10,
      cuPaddingW : 0.101/10,
      cuPaddingH : 0.101/10,
      cuMarginW : .102/10,
    },
    ui:['iodi','温度湿度','空调','BMS','pcs'],
    hotpoi: [
      // {name:'EMS', isBattery:false,x: 0, y: 0, z: 2.4383 * scal/2},
      // {name:'PCS', isBattery:false,x: 3 * scal, y: 0, z: 2.4383 * scal/2},
      // {name:'空调',isBattery:false,x: 2 *scal, y: 0, z: 2.4383 * scal/2},
      // {name:'储能电池',isBattery:1,x: 1*scal, y: 0, z: 2.4383 * scal/2},
    ]
  },
  //一体2列1簇  蓝色
  product2: {
    width: 12.2005 * scal,
    height: 2.896 * scal,
    depth: 3.2737 * scal,
    faceColors: getBoxColors([0, 0, 1, 1]),
    logo:{
      size:0.05,
      poi:[-0.150,1.500,0.600]
    },
    cu:{
      bigcu:[{
        start:[0.225,0.32,0]
      }],
      row:2,
      num:1,
      height:10,
      modelMarginW:0.101/10,
      modelMarginH : 0/10,
      cuPaddingW : 0.101/10,
      cuPaddingH : 0.101/10,
      cuMarginW : .102/10,
    },
    ui:['iodi','温度湿度','空调','BMS','pcs'],
    hotpoi: [
      // {name:'EMS', isBattery:false,x: 0, y: 0, z: 2.4383 * scal/2},
      // {name:'PCS', isBattery:false,x: 3 * scal, y: 0, z: 2.4383 * scal/2},
      // {name:'空调',isBattery:false,x: 2 *scal, y: 0, z: 2.4383 * scal/2},
      // {name:'储能电池',isBattery:1,x: 1*scal, y: 0, z: 2.4383 * scal/2},
    ]
  },
  //一体箱式  艳红
  product3: {
    width: 12.192 * scal,
    height: 2.896 * scal,
    depth: 3.3741 * scal,
    faceColors: getBoxColors([1, 0, 1, 1]),
    logo:{
      size:0.500,
      poi:[-0.200,1.500,1.500]
    },
    cu:{
      bigcu:[{
        start:[-2.85,0.54,-0.7]
      },{
        start:[-2.95,0.54,0.7]
      },],
      row:2,
      num:7,
      height:9,
      // num:1,
      // height:1,
      modelMarginW:0.51/10,
      modelMarginH : 0.01/10,
      cuPaddingW : 0.01/10,
      cuPaddingH : 0.01/10,
      cuMarginW : .42/10,
    },
    ui:['iodi','温度湿度','空调','BMS','pcs'],
    hotpoi: [
      // {name:'EMS', isBattery:false,x: 0, y: 0, z: 2.4383 * scal/2},
      // {name:'PCS', isBattery:false,x: 3 * scal, y: 0, z: 2.4383 * scal/2},
      // {name:'空调',isBattery:false,x: 2 *scal, y: 0, z: 2.4383 * scal/2},
      // {name:'储能电池',isBattery:1,x: 1*scal, y: 0, z: 2.4383 * scal/2},
    ]
  },

  //分体电池仓3簇  黄
  product4: {
    width: 4.6685 * scal,
    height: 2.896 * scal,
    depth: 1.4766 * scal,
    faceColors: getBoxColors([1, 1, 0, 1]),
    logo:{
      size:0.1,
      poi:[-1.800,2.300,0.600]
    },
    cu:{
      bigcu:[{
        start:[-1.85,0.33,0.01]
      },],
      row:2,
      num:3,
      height:9,
      modelMarginW:0.01/10,
      modelMarginH : 0.12/10,
      cuPaddingW : 0.01/10,
      cuPaddingH : 0.01/10,
      cuMarginW : 2.4/10,
    },
    ui:['iodi','温度湿度','空调','BMS'],
    hotpoi: [
      // {name:'EMS', isBattery:false,x: 0, y: 0, z: 2.4383 * scal/2},
      // {name:'PCS', isBattery:false,x: 3 * scal, y: 0, z: 2.4383 * scal/2},
      // {name:'空调',isBattery:false,x: 2 *scal, y: 0, z: 2.4383 * scal/2},
      // {name:'储能电池',isBattery:1,x: 1*scal, y: 0, z: 2.4383 * scal/2},
    ]
  },
  //分体电池仓箱式
  product5: {
    width: 12.192 * scal,
    height: 2.896 * scal,
    depth: 3.3741 * scal,
    faceColors: getBoxColors([0, 1, 1, 1]),
    logo:{
      size:0.500,
      poi:[-0.200,1.500,1.500]
    },
    cu:{
      bigcu:[{
        start:[-3.69,0.54,-0.64]
      },{
        start:[-3.48,0.54,0.75]
      },],
      row:2,
      num:8,
      height:9,
      // num:1,
      // height:1,
      modelMarginW:0.01/10,
      modelMarginH : 0.01/10,
      cuPaddingW : 0.01/10,
      cuPaddingH : 0.01/10,
      cuMarginW : 1.0/10,
    },
    ui:['iodi','温度湿度','空调','BMS'],
    hotpoi: [
      // {name:'EMS', isBattery:false,x: 0, y: 0, z: 2.4383 * scal/2},
      // {name:'PCS', isBattery:false,x: 3 * scal, y: 0, z: 2.4383 * scal/2},
      // {name:'空调',isBattery:false,x: 2 *scal, y: 0, z: 2.4383 * scal/2},
      // {name:'储能电池',isBattery:1,x: 1*scal, y: 0, z: 2.4383 * scal/2},
    ]
  },
  //一体箱式  艳红 22簇
   product6: {
    width: 12.192 * scal,
    height: 2.896 * scal,
    depth: 3.3741 * scal,
    faceColors: getBoxColors([1, 0, 1, 1]),
    logo:{
      size:0.500,
      poi:[-0.200,1.500,1.500]
    },
    cu:{
      bigcu:[{
        start:[-4.38787,0.54,-0.7]
      },{
        start:[-3.918,0.54,0.7]
      },],
      row:2,
      num:10,
      height:9,
      // num:1,
      // height:1,
      modelMarginW:0.26/10,
      modelMarginH : 0.01/10,
      cuPaddingW : 0.01/10,
      cuPaddingH : 0.01/10,
      cuMarginW : .45/10,
    },
    ui:['iodi','温度湿度','空调','BMS','pcs'],
    hotpoi: [
      // {name:'EMS', isBattery:false,x: 0, y: 0, z: 2.4383 * scal/2},
      // {name:'PCS', isBattery:false,x: 3 * scal, y: 0, z: 2.4383 * scal/2},
      // {name:'空调',isBattery:false,x: 2 *scal, y: 0, z: 2.4383 * scal/2},
      // {name:'储能电池',isBattery:1,x: 1*scal, y: 0, z: 2.4383 * scal/2},
    ]
  },
  //一体2列3簇  蓝色
  product7: {
    width: 4.64 * scal,
    height: 1.2 * scal,
    depth: 2.896 * scal,
    faceColors: getBoxColors([0, 0, 1, 1]),
    logo:{
      size:0.05,
      poi:[-2,2.800,0.65]
    },
    cu:{
      bigcu:[{
        start:[-2.28,-0.12,-0.4]
      }],
      row:2,
      num:3,
      height:9,
      modelMarginW:0.101/10,
      modelMarginH : 0/10,
      cuPaddingW : 0.101/10,
      cuPaddingH : 0.101/10,
      cuMarginW : 2.02/10,
    },
    ui:['iodi','温度湿度','空调','BMS','pcs'],
    hotpoi: [
      // {name:'EMS', isBattery:false,x: 0, y: 0, z: 2.4383 * scal/2},
      // {name:'PCS', isBattery:false,x: 3 * scal, y: 0, z: 2.4383 * scal/2},
      // {name:'空调',isBattery:false,x: 2 *scal, y: 0, z: 2.4383 * scal/2},
      // {name:'储能电池',isBattery:1,x: 1*scal, y: 0, z: 2.4383 * scal/2},
    ]
  },
  //干湿升压变
  dryandwet: {
    width: 12.2005 * scal,
    height: 2.896 * scal,
    depth: 3.2737 * scal,
    faceColors: getBoxColors([0, 0, 1, 1]),
    logo:{
      size:0.05,
      poi:[-0.150,1.500,0.600]
    },
    cu:{
      bigcu:[{
        start:[0.225,0.32,0]
      }],
      row:2,
      num:1,
      height:10,
      modelMarginW:0.101/10,
      modelMarginH : 0/10,
      cuPaddingW : 0.101/10,
      cuPaddingH : 0.101/10,
      cuMarginW : .102/10,
    },
    ui:['iodi','温度湿度','空调','BMS','pcs'],
    hotpoi: [
      // {name:'EMS', isBattery:false,x: 0, y: 0, z: 2.4383 * scal/2},
      // {name:'PCS', isBattery:false,x: 3 * scal, y: 0, z: 2.4383 * scal/2},
      // {name:'空调',isBattery:false,x: 2 *scal, y: 0, z: 2.4383 * scal/2},
      // {name:'储能电池',isBattery:1,x: 1*scal, y: 0, z: 2.4383 * scal/2},
    ]
  },
  //功率仓  白
  powerBox: {
    width: 6.096 * scal,
    height: 2.8956 * scal,
    depth: 2.4383 * scal,
    faceColors: getBoxColors([1, 1, 1, 1]),
    logo:{
      size:0.500,
      poi:[-0.200,1.500,1.300]
    },
    ui:['pcs3'],
    hotpoi: [
      // {name:'power', isBattery:false,x: 0 * scal, y: 0, z: 2.4383 * scal/2},
    ]
  },
  //电气仓  黑
  electricalBox: {
    width: 1.09378 * scal,
    height: 1.843 * scal,
    depth: 0.65494 * scal,
    faceColors: getBoxColors([0, 0, 0, 1]),
    logo:{
      size:0.05,
      poi:[-0.250,1.500,0.340]
    },
    ui:['pcs'],
    hotpoi: [
      // {name:'PCS', isBattery:false,x: 0 * scal, y: 0, z: 2.4383 * scal/2},
    ]
  },
  //电气仓  黑
  light: {
    width: 1.09378 * scal,
    height: 1.843 * scal,
    depth: 0.65494 * scal,
    faceColors: getBoxColors([0, 0, 0, 1]),
    ui:[],
    hotpoi: [
      // {name:'PCS', isBattery:false,x: 0 * scal, y: 0, z: 2.4383 * scal/2},
    ]
  },
  //电气仓  黑
  tower: {
    width: 1.09378 * scal,
    height: 1.843 * scal,
    depth:0.65494 * scal,
    faceColors: getBoxColors([0, 0, 0, 1]),
    ui:[],
    hotpoi: [
      // {name:'PCS', isBattery:false,x: 0 * scal, y: 0, z: 2.4383 * scal/2},
    ]
  },
  //电气仓  黑
  park: {
    width: 1.09378 * scal,
    height: 1.843 * scal,
    depth: 0.65494 * scal,
    faceColors: getBoxColors([0, 0, 0, 1]),
    ui:[],
    hotpoi: [
      // {name:'PCS', isBattery:false,x: 0 * scal, y: 0, z: 2.4383 * scal/2},
    ]
  },
  //电气仓  黑
  wind: {
    width: 1.09378 * scal,
    height: 1.843 * scal,
    depth: 0.65494 * scal,
    faceColors: getBoxColors([0, 0, 0, 1]),
    ui:[],
    hotpoi: [
      // {name:'PCS', isBattery:false,x: 0 * scal, y: 0, z: 2.4383 * scal/2},
    ]
  },
  //电池模块  绿
  battery: {
    width: 0.50405,
    height: 0.2298 ,
    depth: 0.647 ,
    faceColors: getBoxColors([0, 1, 0, 1])
  },
  //高压模块  红
  highVoltage: {
    width: 0.50405,
    height: 0.2298 ,
    depth: 0.647 ,
    faceColors: getBoxColors([1, 0, 0, 1])
  },
  fenceCorner: {
    width: 0.3 * scal,
    height: 0.3 * scal,
    depth: 0.3 * scal,
    faceColors: getBoxColors([0, 0, 0, 1])
  },
  fence: {
    width: 1 * scal,
    height: 0.3 * scal,
    depth: 0.3 * scal,
    faceColors: getBoxColors([0, 0, 0, 1])
  }
};



// WEBPACK FOOTER //
// ./src/components/webgl/LevelsShow/config.js